"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class ModbusModel extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'modbusModel';
        this._displayName = initParams.display_name;
        this._modbusDeviceType = initParams.modbus_device_type;
        this._modbusManufacturerName = initParams.modbus_manufacturer_name;
        this._modbusProductName = initParams.modbus_product_name;
        this._sku = initParams.sku;
        this._manufacturerSku = initParams.manufacturer_sku;
        this._displayImage = initParams.display_image;
        this._parity = initParams.parity;
        this._baudRate = initParams.baud_rate;
        this._stopBits = initParams.stop_bits;
        this._dataBits = initParams.data_bits;
        this._rxTimeout = initParams.rx_timeout;
        this._registers = (0, util_1.camelArray)(initParams.registers);
        this._readOnly = initParams.read_only;
        this._organisationId = initParams.organisation_id;
        this._global = initParams.global;
        this.__permission = initParams._permission;
    }
    set displayName(value) {
        console.error('Do not set objects this way');
    }
    setDisplayName(value) {
        return this.dataService.updateModbusModel(this.id, { display_name: value }, this);
    }
    get displayName() {
        return this._displayName;
    }
    set modbusDeviceType(value) {
        console.error('Do not set objects this way');
    }
    setModbusDeviceType(value) {
        return this.dataService.updateModbusModel(this.id, { modbus_device_type: value }, this);
    }
    get modbusDeviceType() {
        return this._modbusDeviceType;
    }
    set modbusManufacturerName(value) {
        console.error('Do not set objects this way');
    }
    setModbusManufacturerName(value) {
        return this.dataService.updateModbusModel(this.id, { modbus_manufacturer_name: value }, this);
    }
    get modbusManufacturerName() {
        return this._modbusManufacturerName;
    }
    set modbusProductName(value) {
        console.error('Do not set objects this way');
    }
    setModbusProductName(value) {
        return this.dataService.updateModbusModel(this.id, { modbus_product_name: value }, this);
    }
    get modbusProductName() {
        return this._modbusProductName;
    }
    set sku(value) {
        console.error('Do not set objects this way');
    }
    setSku(value) {
        return this.dataService.updateModbusModel(this.id, { sku: value }, this);
    }
    get sku() {
        return this._sku;
    }
    set manufacturerSku(value) {
        console.error('Do not set objects this way');
    }
    setManufacturerSku(value) {
        return this.dataService.updateModbusModel(this.id, { manufacturer_sku: value }, this);
    }
    get manufacturerSku() {
        return this._manufacturerSku;
    }
    set displayImage(value) {
        console.error('Do not set objects this way');
    }
    setDisplayImage(value) {
        return this.dataService.updateModbusModel(this.id, { display_image: value }, this);
    }
    get displayImage() {
        return this._displayImage;
    }
    set parity(value) {
        console.error('Do not set objects this way');
    }
    setParity(value) {
        return this.dataService.updateModbusModel(this.id, { parity: value }, this);
    }
    get parity() {
        return this._parity;
    }
    set baudRate(value) {
        console.error('Do not set objects this way');
    }
    setBaudRate(value) {
        return this.dataService.updateModbusModel(this.id, { baud_rate: value }, this);
    }
    get baudRate() {
        return this._baudRate;
    }
    set stopBits(value) {
        console.error('Do not set objects this way');
    }
    setStopBits(value) {
        return this.dataService.updateModbusModel(this.id, { stop_bits: value }, this);
    }
    get stopBits() {
        return this._stopBits;
    }
    set dataBits(value) {
        console.error('Do not set objects this way');
    }
    setDataBits(value) {
        return this.dataService.updateModbusModel(this.id, { data_bits: value }, this);
    }
    get dataBits() {
        return this._dataBits;
    }
    set rxTimeout(value) {
        console.error('Do not set objects this way');
    }
    setRxTimeout(value) {
        return this.dataService.updateModbusModel(this.id, { rx_timeout: value }, this);
    }
    get rxTimeout() {
        return this._rxTimeout;
    }
    set registers(value) {
        console.error('Do not set objects this way');
    }
    setRegisters(value) {
        return this.dataService.updateModbusModel(this.id, { registers: (0, util_1.snakeArray)(value) }, this);
    }
    get registers() {
        return this._registers;
    }
    set readOnly(value) {
        console.error('Do not set objects this way');
    }
    setReadOnly(value) {
        return this.dataService.updateModbusModel(this.id, { read_only: value }, this);
    }
    get readOnly() {
        return this._readOnly;
    }
    set organisationId(value) {
        console.error('Do not set objects this way');
    }
    setOrganisationId(value) {
        return this.dataService.updateModbusModel(this.id, { organisation_id: value }, this);
    }
    get organisationId() {
        return this._organisationId;
    }
    set global(value) {
        console.error('Do not set objects this way');
    }
    setGlobal(value) {
        return this.dataService.updateModbusModel(this.id, { global: value }, this);
    }
    get global() {
        return this._global;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateModbusModel(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateModbusModel(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteModbusModel(this.id, this);
    }
}
exports.default = ModbusModel;
//# sourceMappingURL=modbusModel.js.map